<template>
  <div id="hres82e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :unLoadBool="true"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres82eIndex"
            searchBoxAlias="hres82e"
            :detailEvent="roomDetailEvent"
            :editEvent="editEvent" />

    <room-detail v-show="roomDetailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="roomDetail"
            :toggle="toggle"
            :nowLang="app.nowLang" />

    <detail  v-show="detailDisp"
            :calendarDetailDisp="calendarDetailDisp"
            :reserveDisp="reserveDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :toggle="toggle"
            :nowLang="app.nowLang"
            :reserveDay="reserveDay"
            :reserveDate="reserveDate"
            :reserveMonth="reserveMonth"
            :reserveYear="reserveYear"
            :searchIndex="searchIndex"
            :dateSelected="dateSelected"
            :indexSelected="indexSelected"
            :calendarSelected="calendarSelected"
            :setDateSelected="setDateSelected"
            :setCalendarSelected="setCalendarSelected"
            :calendar="calendar"
            :calendarDetail="calendarDetail"
            :reserveDetail="reserveDetail"
            :detailColumns="columns[app.nowLang].detail"
            :descCodapp="app.$children[0].descCodapp"
            :receivedHres82eCalendar="receivedHres82eCalendar"
            :receivedHres82eReserveCreate="receivedHres82eReserveCreate"
            :receivedHres82eReserveDetail="receivedHres82eReserveDetail"
            :postHres82eReserveCancel="postHres82eReserveCancel"
            :postHres82eReserveSave="postHres82eReserveSave" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres82e/mutation-types'
import roomDetail from 'components/hres82e/roomDetail'
import detail from 'components/hres82e/detail'
import reserve from 'components/hres82e/reserve'
import moment from 'moment'

export default {
  name: 'hres82e',
  data () {
    return {
      searchIndex: {
        dtereserv: moment().format('DD/MM/YYYY')
      },
      app: this.$parent.$parent.$parent,
      currentDtereq: moment().format('DD/MM/YYYY'),
      currentNumseq: 1
    }
  },
  created () {
    this.receivedHres82eColumnsLabels()
  },
  computed: {
    reserveDay () {
      return this.dateSelected.length === 10 ? new Date(this.reserveYear, this.reserveMonth - 1, this.reserveDate).getDay() : ''
    },
    reserveDate () {
      return this.dateSelected.length === 10 ? this.dateSelected.substring(0, 2) : ''
    },
    reserveMonth () {
      return this.dateSelected.length === 10 ? this.dateSelected.substring(3, 5) : ''
    },
    reserveYear () {
      return this.dateSelected.length === 10 ? this.dateSelected.substring(6, 10) : ''
    },
    ...mapGetters({
      indexDisp: types.GET_HRES82E_INDEX_DISP,
      roomDetailDisp: types.GET_HRES82E_ROOM_DETAIL_DISP,
      detailDisp: types.GET_HRES82E_DETAIL_DISP,
      calendarDetailDisp: types.GET_HRES82E_CALENDAR_DETAIL_DISP,
      reserveDisp: types.GET_HRES82E_RESERVE_DISP,
      columns: types.GET_HRES82E_COLUMNS,
      labels: types.GET_HRES82E_LABELS,
      index: types.GET_HRES82E_INDEX,
      indexSelected: types.GET_HRES82E_INDEX_SELECTED,
      calendarSelected: types.GET_HRES82E_CALENDAR_SELECTED,
      dateSelected: types.GET_HRES82E_DATE_SELECTED,
      roomDetail: types.GET_HRES82E_ROOM_DETAIL,
      calendar: types.GET_HRES82E_CALENDAR,
      calendarDetail: types.GET_HRES82E_CALENDAR_DETAIL,
      reserveDetail: types.GET_HRES82E_RESERVE_DETAIL
    })
  },
  watch: {
    dateSelected () {
      this.receivedCalendarDetail()
    }
  },
  methods: {
    receivedCalendarDetail () {
      if (typeof this.indexSelected.roomno !== 'undefined') {
        let searchParams = {
          roomno: this.indexSelected.roomno,
          dtereserv: this.dateSelected
        }
        this.receivedHres82eCalendarDetail(searchParams)
      }
    },
    pageDetail (event, param) {
      switch (event) {
        case 'roomDetail':
          if (param.roomno) {
            let searchParams = {
              roomno: param.roomno
            }
            this.receivedHres82eRoomDetail(searchParams)
            this.toggle('roomDetail')
          }
          break
        case 'detail':
          this.setDateSelected(this.searchIndex.dtereserv)
          let searchParams = {
            roomno: param.roomno,
            dtemonth: this.reserveMonth,
            dteyear: this.reserveYear
          }
          this.receivedHres82eCalendar(searchParams)
          this.receivedCalendarDetail()
          this.toggle('detail')
          break
        default:
          break
      }
    },
    roomDetailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('roomDetail', param)
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('detail', param)
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES82E_INDEX_SELECTED,
      setCalendarSelected: types.SET_HRES82E_CALENDAR_SELECTED,
      setDateSelected: types.SET_HRES82E_DATE_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES82E_PAGE,
      receivedHres82eColumnsLabels: types.RECEIVED_HRES82E_COLUMNS_LABELS,
      receivedHres82eIndex: types.RECEIVED_HRES82E_INDEX,
      receivedHres82eRoomDetail: types.RECEIVED_HRES82E_ROOM_DETAIL,
      receivedHres82eCalendar: types.RECEIVED_HRES82E_CALENDAR,
      receivedHres82eCalendarDetail: types.RECEIVED_HRES82E_CALENDAR_DETAIL,
      receivedHres82eReserveCreate: types.RECEIVED_HRES82E_RESERVE_CREATE,
      receivedHres82eReserveDetail: types.RECEIVED_HRES82E_RESERVE_DETAIL,
      postHres82eReserveCancel: types.POST_HRES82E_RESERVE_CANCEL,
      postHres82eReserveSave: types.POST_HRES82E_RESERVE_SAVE
    })
  },
  components: {
    roomDetail,
    detail,
    reserve
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?782ed982